import {createContext} from "react";
import {iSquad, StatusMember} from "./useSquadInterfaces";

const defaultValue = {
	users: [],
	instanceId: undefined,
	squads: [],
	Actions: {
		instance: {
			create: () => {},
			join: (uuid: string) => {},
			leave: () => {}
		},
		squads: {
			create: (name: string, callSign: string) => {},
			join: (squadId: string, member: {id: string, name: string}) => {},
			leave: (memberId: string) => {},
			update: (squadId: string, name: string, callSign: string) => {},
			updateMemberStatus: (memberId: string, status: StatusMember) => {},
			toggleSupport: (squadId: string) => {},
			addObjective: (squadId: string, name: string) => {},
			toggleObjective: (squadId: string, objectiveName: string) => {},
			deleteObjective: (squadId: string, objectiveName: string) => {},
			delete: (squadId: string) => {}
		}
	}
}

interface SquadContextProviderProps {
	users: {id: string, name: string}[],
	instanceId?: string,
	squads: iSquad[],
	Actions: {
		instance: {
			create: () => void,
			join: (uuid: string) => void,
			leave: () => void
		},
		squads: {
			create: (name: string, callSign: string) => void,
			join: (squadId: string, member: {id: string, name: string}) => void,
			leave: (memberId: string) => void,
			update: (squadId: string, name: string, callSign: string) => void,
			updateMemberStatus: (memberId: string, status: StatusMember) => void,
			toggleSupport: (squadId: string) => void,
			addObjective: (squadId: string, name: string) => void,
			toggleObjective: (squadId: string, objectiveName: string) => void,
			deleteObjective: (squadId: string, objectiveName: string) => void,
			delete: (squadId: string) => void
		}
	}
}


export const SquadContext = createContext<SquadContextProviderProps>( defaultValue );